import { useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import OrderOverview from "../components/OrderOverview";
import Button from "../components/ui/Button";
import Input from "../components/ui/Input";
import LoadingScreen from "../components/ui/LoadingScreen";
import { track } from "../utils/analytics";
import { useVerifyCertificate } from "../utils/api";

export default function OrderProcess() {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const [zipCode, setZipCode] = useState("");
  const [minLoading, setMinLoading] = useState(false);

  const { mutate: verifyOrder, isPending, error, data } = useVerifyCertificate();
  const handleSubmit = (e) => {
    e.preventDefault();
    setMinLoading(true);
    verifyOrder(
      { orderId, zipCode },
      {
        onSuccess: () =>
          track("Verification Submitted", {
            order_id: orderId,
            success: true,
            error_message: null,
          }),
        onError: (err) =>
          track("Verification Submitted", {
            order_id: orderId,
            success: false,
            error_message: err?.message ?? null,
          }),
      },
    );
    setTimeout(() => {
      setMinLoading(false);
    }, 1200);
  };

  const showLoader = isPending || minLoading;

  // VIEW 1: Show the loader
  if (showLoader) {
    return <LoadingScreen />;
  }

  // VIEW 2: Show the success state with nested routes
  if (data) {
    return (
      <>
        <OrderOverview data={data} orderId={orderId} zipCode={zipCode} />
        <Outlet context={{ data, zipCode }} />
      </>
    );
  }

  // VIEW 3: Show the form state
  return (
    <div className="w-full max-w-lg z-10 animate-slide-up">
      <form onSubmit={() => console.log("Submit!")} className="space-y-16">
        {/* form 'label' */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 mb-2 font-mono text-xs text-collectors-gray">
            <span>ORDER: {orderId}</span>
            <div className="mb-[2px] w-2 h-2 rounded-full bg-green-500"></div>
            <span className="text-green-500">FOUND</span>
          </div>
          <h2 className="font-display font-medium uppercase text-5xl md:text-7xl tracking-tighter leading-[0.9] -ms-1">
            Verify
            <br />
            Ownership
          </h2>
          <p className="font-mono uppercase text-xs text-collectors-gray max-w-sm pt-4">
            To access your digital certificates, please confirm the delivery postal code associated
            with this order.
          </p>
        </div>

        <div className="space-y-4 relative">
          <Input
            label="Postal Code"
            placeholder="XXXXX"
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
            autoFocus
          />
          {error && (
            <p className="font-mono text-[10px] text-red-600 uppercase tracking-widest">
              {error.message}
            </p>
          )}

          <div className="pt-4">
            <Button onClick={handleSubmit} type="submit" className="w-full" disabled={!zipCode}>
              Confirm Postal Code
            </Button>
          </div>
        </div>

        <button
          type="button"
          onClick={() => navigate("/")}
          className="text-sm font-mono uppercase text-collectors-gray hover:text-collectors-black underline decoration-dotted underline-offset-4"
        >
          ← Return to Order Entry
        </button>
      </form>
    </div>
  );
}
